import { emptySplitApi } from './baseApi';

interface PlatformStatus {
  platform: string;
  status: string;
  last_refreshed_at: string | null;
  access_token_expiry: string | null;
  refresh_token_expiry: string | null;
  error_message: string | null;
  updated_at: string | null;
}

interface OAuthStatusResponse {
  platforms: PlatformStatus[];
}

interface OAuthRefreshResponse {
  platform: string;
  status: string;
  message: string;
}

interface AuthorizeResponse {
  authorize_url: string;
}

export const oauthApiSlice = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchOAuthStatus: builder.query<OAuthStatusResponse, void>({
      query: () => ({
        url: '/oauth/status',
        method: 'GET',
      }),
      providesTags: ['OAuthStatus'],
    }),
    getAuthorizeUrl: builder.query<AuthorizeResponse, string>({
      query: (platform) => ({
        url: `/oauth/${platform}/authorize`,
        method: 'GET',
      }),
    }),
    refreshPlatformToken: builder.mutation<OAuthRefreshResponse, string>({
      query: (platform) => ({
        url: `/oauth/${platform}/refresh`,
        method: 'POST',
      }),
      invalidatesTags: ['OAuthStatus'],
    }),
    disconnectPlatform: builder.mutation<
      { platform: string; status: string },
      string
    >({
      query: (platform) => ({
        url: `/oauth/${platform}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['OAuthStatus'],
    }),
  }),
});

export const {
  useFetchOAuthStatusQuery,
  useLazyGetAuthorizeUrlQuery,
  useRefreshPlatformTokenMutation,
  useDisconnectPlatformMutation,
} = oauthApiSlice;
